import React from 'react';
import { Link } from 'react-router-dom';

function TrialExpired() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '2.5rem', width: '100%', maxWidth: '480px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏰</div>
        <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.5rem', color: '#111827' }}>Your Trial Has Expired</h2>
        <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
          Your free trial period has ended. Upgrade to a paid plan to continue using the system.
        </p>
        <div style={{ background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem', fontSize: '0.9rem', color: '#92400e' }}>
          Contact your administrator or support to upgrade your plan.
        </div>
        <a
          href="https://oleocotech.com/#contact"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block', background: '#2563eb', color: '#fff', padding: '0.75rem 1.5rem', borderRadius: '6px', textDecoration: 'none', fontWeight: 600, marginBottom: '1rem' }}
        >
          Contact Support
        </a>
        <div style={{ marginTop: '1rem' }}>
          <Link to="/login" style={{ color: '#6b7280', fontSize: '0.9rem' }}>← Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

export default TrialExpired;
